import { AccountObject } from "./account-object.model";
import { IAclFilter } from "../../store/queries/acl-filter.interface";
import { dictionarySelector, listSelector, Qry } from "../query-facade";
import { createSelector } from "reselect";
import { RestrictedAccountObject } from "./restricted-account-object.model";
import { isInArray } from "../../../core/util/is-in-array";
import { Membership } from "../membership/membership.model";
import { User } from "../user/user.model";
import { AclFilter } from "../../store/queries/acl-filter";
import { IAclFilterCustomCheck } from "../../store/queries/acl-filter-custom-check.interface";
import { AppConfig } from "../../../app/app.config";

export class RestrictedAccountObjectAclFilterCategoryCheck<T extends RestrictedAccountObject> implements IAclFilterCustomCheck<T> {

    constructor(protected itemProperty: string, protected membershipProperty: string) {

    }

    hasAccess(item: T, membership: Membership, user: User): boolean {
        return isInArray(item[this.itemProperty], membership[this.membershipProperty]);
    }
}

export class RestrictedAccountObjectAclFilter<T extends RestrictedAccountObject> extends AclFilter<T> implements IAclFilter<T> {

    createSelector(idsSelector: listSelector<string>, entitiesSelector: dictionarySelector<T>): listSelector<T> {

        return createSelector(
            idsSelector,
            entitiesSelector,
            this.activeUserMembershipsByAccount,
            this.isAccountOwnerByAccount,
            this.selectedUser,
            (ids, entities, activeUserMembershipsByAccount, isAccountOwnerByAccount, user) => {
                return ids
                    .map(id => entities[id])
                    .filter(item => {

                        const membership = activeUserMembershipsByAccount[item.account];
                        const isOwner = isAccountOwnerByAccount[item.account];

                        if (!membership) {
                            return false;
                        }

                        if (isOwner || membership.admin) {
                            return true;
                        }

                        if (!isInArray(item.accessGroup, membership.accessGroups)) {
                            AppConfig.debugQueries && console.log("rao accessGroup check failed", item);
                            return false;
                        }

                        return this.customChecks.length === this.customChecks
                            .filter(check => {
                                const result = check.hasAccess(item, membership, user);

                                if (!result) {
                                    AppConfig.debugQueries && console.log("rao custom check failed", check, item, membership, user);
                                }

                                return result;
                            }).length;
                    });
            }
        );
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/restricted-account-object/restricted-account-object.acl-filter.ts